import Vue from "vue";
import Vuex from "vuex";
import graduatetrainee from "./Store/graduatetrainee"


Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    graduatetrainee,
  }
});
